import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy public path from before the Resources -> Insights rename.
// Kept as a permanent redirect so old links and indexed URLs still land somewhere.
export const Route = createFileRoute("/resources")({
  loader: () => {
    throw redirect({ to: "/insight/", statusCode: 301 });
  },
});
